import { Text } from "@clipboard-health/ui-components";

import { type PaymentsListItem } from "../types/PaymentsListItem";

export interface PaymentsListItemTitleProps {
  item: PaymentsListItem;
}

export function PaymentsListItemTitle(props: PaymentsListItemTitleProps) {
  return (
    <Text semibold variant="body1">
      {getTitleText(props.item)}
    </Text>
  );
}

function getTitleText(item: PaymentsListItem): string {
  if (item.workplace) {
    return item.workplace.attributes.name;
  }

  if (
    item.attributes.paymentCategory === "manual-bonus" ||
    item.attributes.paymentCategory === "etp-bonus"
  ) {
    return "Bonus";
  }

  return "Unknown";
}
